import { render, staticRenderFns } from "./radiusBox.vue?vue&type=template&id=d6c1bbbc&scoped=true"
import script from "./radiusBox.vue?vue&type=script&lang=js"
export * from "./radiusBox.vue?vue&type=script&lang=js"
import style0 from "./radiusBox.vue?vue&type=style&index=0&id=d6c1bbbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c1bbbc",
  null
  
)

export default component.exports